import Vue from "vue";
import VueDragDrop from 'vue-drag-drop';

Vue.use(VueDragDrop);
